import { buildLocationJsonLd } from './location';
import { buildProviderJsonLd } from './provider';
import { buildMedicalWebPageJsonLd, buildServiceJsonLd } from './specialty';
import { buildGeneralPageJsonLd } from './generalpages';
import {
  GENERAL_PAGE_T1_TEMPLATE_ID,
  GENERAL_PAGE_T2_TEMPLATE_ID,
  PageTemplateIds,
  SiteNames,
} from 'lib/constants';
import { Page } from '@sitecore-content-sdk/nextjs';
import { Pages } from '.generated/Project.CW.model';
import { Data } from '.generated/Foundation.CW.model';
import { getPageUrl } from 'lib/utils/get-base-url';
import { buildBlogDetailJsonLd } from './blog';
import { buildHomePageJsonLd } from './home';

export interface BuildSchemaForRouteArgs {
  page: Page | null;
  pagePath: string;
}

export function buildSchemaForRoute({ page, pagePath }: BuildSchemaForRouteArgs) {
  const templateId = page?.layout.sitecore.route?.templateId;
  const routeFields = page?.layout.sitecore.route;
  const pageUrl = getPageUrl(pagePath);
  const siteName = page?.siteName?.toLowerCase();

  if (siteName != SiteNames.childrens) {
    return null;
  }

  switch (templateId) {
    case PageTemplateIds.locationPage:
    case PageTemplateIds.locationMentalHealth:
    case PageTemplateIds.locationPrimaryCare:
    case PageTemplateIds.locationSpecialtyCare:
    case PageTemplateIds.locationUrgentCare:
    case PageTemplateIds.locationHospital:
      return buildLocationJsonLd(
        templateId,
        routeFields as Data.BaseTemplateSections.Location,
        pageUrl
      );

    case PageTemplateIds.providerProfile:
      return buildProviderJsonLd(routeFields as Pages.ProviderProfile, pageUrl);

    case PageTemplateIds.specialtyPage:
      return [
        buildMedicalWebPageJsonLd(routeFields as Pages.Specialty, pageUrl),
        buildServiceJsonLd(routeFields as Pages.Specialty, pageUrl),
      ];

    case PageTemplateIds.blogDetailPage:
      return buildBlogDetailJsonLd(routeFields as Pages.BlogDetailPage, pageUrl);

    case GENERAL_PAGE_T1_TEMPLATE_ID:
    case GENERAL_PAGE_T2_TEMPLATE_ID:
      return buildGeneralPageJsonLd(routeFields as Pages.ConditionOrTreatment, pageUrl);

    case PageTemplateIds.homePage:
      return buildHomePageJsonLd(pageUrl);

    default:
      return null;
  }
}
